/*
  Ön Sipariş sepet izolasyonu.
  Kural: 'on-siparis' etiketli bir ürün sepetteyken sepete sadece o ürünün
  (ayni handle) farkli beden/renk varyantlari eklenebilir. Normal urun veya
  farkli bir on siparis urunu eklenemez. Normal urun varken on siparis eklenemez.
  Uyumsuz durum olusursa (dogrudan API vb.) odeme adimi da engellenir.

  Tespit: urun formuna basilan gizli alan name="properties[_preorder]" = handle.
  Sepet durumu /cart.js line item properties uzerinden okunur.
*/
(function () {
  var S = window.preorderCartStrings || {};

  var SELECTORS = {
    productForm: 'form.product-single__form',
    addBtn: '.add-to-cart',
    paymentWrap: '.payment-buttons',
    cartPageForm: 'CartPageForm',
    cartDrawerForm: 'CartDrawerForm',
    checkoutBtn: 'button.cart__checkout, button[name="checkout"]',
    expressButtons: '.additional-checkout-buttons'
  };

  var state = null; // /cart.js property tabanli yedek durum (drawer/cart DOM yoksa)
  var optimistic = { handles: [], hasNormal: false, count: 0 };
  var refreshing = false;
  var refreshAgain = false;
  var reconcileTimer = null;

  function resetOptimistic() {
    optimistic = { handles: [], hasNormal: false, count: 0 };
  }

  /* ---------- yardimcilar ---------- */

  function cartUrl() {
    return (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
  }

  function readPreorderHandle(form) {
    var inp = form.querySelector('input[name="properties[_preorder]"]');
    return inp && inp.value ? inp.value : null;
  }

  function classify(cart) {
    var handles = {};
    var hasNormal = false;
    var items = (cart && cart.items) || [];
    items.forEach(function (it) {
      var h = it.properties && it.properties._preorder;
      if (h) {
        handles[h] = true;
      } else {
        hasNormal = true;
      }
    });
    return {
      preorderHandles: Object.keys(handles),
      hasNormal: hasNormal,
      itemCount: (cart && cart.item_count) || 0
    };
  }

  // Tag tabanli kaynak (rozetle ayni): her zaman acik sepet drawer'i / cart sayfasi DOM'u.
  // Urunun ne zaman/nasil eklendigine bakmaksizin gercek urun etiketinden okur.
  function domCartState() {
    var items = document.querySelectorAll('.cart__item');
    if (!items.length) return null;
    var handles = {};
    var hasNormal = false;
    items.forEach(function (it) {
      var h = it.getAttribute('data-preorder-handle');
      if (h) {
        handles[h] = true;
      } else {
        hasNormal = true;
      }
    });
    return { preorderHandles: Object.keys(handles), hasNormal: hasNormal, itemCount: items.length };
  }

  function withOptimistic(base) {
    var handles = {};
    base.preorderHandles.forEach(function (h) { handles[h] = true; });
    optimistic.handles.forEach(function (h) { handles[h] = true; });
    return {
      preorderHandles: Object.keys(handles),
      hasNormal: base.hasNormal || optimistic.hasNormal,
      itemCount: (base.itemCount || 0) + optimistic.count
    };
  }

  function getState() {
    var base = domCartState() || state;
    if (!base) return null;
    return withOptimistic(base);
  }

  function canAdd(addingHandle) {
    var s = getState();
    if (!s) return { ok: true };
    if (addingHandle) {
      if (s.itemCount === 0) return { ok: true };
      if (s.hasNormal) return { ok: false, message: S.blockMixNormalWithPreorder };
      var others = s.preorderHandles.filter(function (h) { return h !== addingHandle; });
      if (others.length) return { ok: false, message: S.blockDifferentPreorder };
      return { ok: true };
    }
    if (s.preorderHandles.length) return { ok: false, message: S.blockNormalWhilePreorder };
    return { ok: true };
  }

  function currentConflict() {
    var s = getState();
    if (!s) return false;
    var p = s.preorderHandles.length;
    return p >= 2 || (p >= 1 && s.hasNormal);
  }

  /* ---------- bildirim (toast) ---------- */

  var toastTimer = null;
  function notify(msg) {
    if (!msg) return;
    var el = document.querySelector('.preorder-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'preorder-toast';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'assertive');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 4500);
  }

  /* ---------- urun butonlari ---------- */

  function showNote(form, text) {
    if (!text) return;
    var note = form.querySelector('.preorder-block-note');
    if (!note) {
      note = document.createElement('div');
      note.className = 'preorder-block-note';
      var btn = form.querySelector(SELECTORS.addBtn);
      var anchor = (btn && btn.closest(SELECTORS.paymentWrap)) || btn;
      if (anchor && anchor.parentNode) {
        anchor.insertAdjacentElement('afterend', note);
      } else {
        form.appendChild(note);
      }
    }
    note.textContent = text;
  }

  function removeNote(form) {
    var note = form.querySelector('.preorder-block-note');
    if (note) note.parentNode.removeChild(note);
  }

  function applyToForms() {
    var forms = document.querySelectorAll(SELECTORS.productForm);
    forms.forEach(function (form) {
      var btn = form.querySelector(SELECTORS.addBtn);
      if (!btn) return;
      var addingHandle = readPreorderHandle(form);
      var verdict = canAdd(addingHandle);
      if (verdict.ok) {
        btn.classList.remove('is-preorder-disabled');
        btn.removeAttribute('aria-disabled');
        removeNote(form);
      } else {
        btn.classList.add('is-preorder-disabled');
        btn.setAttribute('aria-disabled', 'true');
        showNote(form, verdict.message || (addingHandle ? S.disabledNotePreorder : S.disabledNoteNormal));
      }
    });
  }

  /* ---------- sepet / odeme ---------- */

  function applyToCart() {
    var conflict = currentConflict();

    document.querySelectorAll(SELECTORS.checkoutBtn).forEach(function (btn) {
      if (conflict) {
        btn.classList.add('is-preorder-disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.disabled = true;
      } else {
        btn.classList.remove('is-preorder-disabled');
        btn.removeAttribute('aria-disabled');
        btn.disabled = false;
      }
    });

    document.querySelectorAll(SELECTORS.expressButtons).forEach(function (el) {
      el.classList.toggle('preorder-hidden', conflict);
    });

    [SELECTORS.cartPageForm, SELECTORS.cartDrawerForm].forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      var banner = form.querySelector('.preorder-cart-warning');
      if (conflict) {
        if (!banner) {
          banner = document.createElement('div');
          banner.className = 'preorder-cart-warning';
          var anchor = form.querySelector('[data-products]');
          if (anchor && anchor.parentNode) {
            anchor.parentNode.insertBefore(banner, anchor);
          } else {
            form.insertBefore(banner, form.firstChild);
          }
        }
        banner.textContent = S.checkoutConflict || '';
      } else if (banner) {
        banner.parentNode.removeChild(banner);
      }
    });
  }

  function applyAll() {
    applyToForms();
    applyToCart();
  }

  /* ---------- durum guncelleme ---------- */

  function refresh() {
    if (refreshing) {
      refreshAgain = true;
      return;
    }
    refreshing = true;
    fetch(cartUrl(), { credentials: 'same-origin', method: 'GET' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state = classify(cart);
        resetOptimistic();
        applyAll();
      })
      .catch(function () {})
      .then(function () {
        refreshing = false;
        if (refreshAgain) {
          refreshAgain = false;
          refresh();
        }
      });
  }

  function scheduleReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(refresh, 1200);
  }

  function optimisticAdd(addingHandle) {
    if (addingHandle) {
      if (optimistic.handles.indexOf(addingHandle) < 0) {
        optimistic.handles.push(addingHandle);
        optimistic.count += 1;
      }
    } else if (!optimistic.hasNormal) {
      optimistic.hasNormal = true;
      optimistic.count += 1;
    }
    applyAll();
    scheduleReconcile();
  }

  /* ---------- yakalama: ekleme ve odeme ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.id === SELECTORS.cartPageForm || form.id === SELECTORS.cartDrawerForm) {
      if (currentConflict()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        notify(S.checkoutConflict);
      }
      return;
    }

    var isProductForm =
      form.classList.contains('product-single__form') ||
      (form.action && form.action.indexOf('/cart/add') > -1);
    if (!isProductForm) return;

    var addingHandle = readPreorderHandle(form);
    var verdict = canAdd(addingHandle);
    if (!verdict.ok) {
      e.preventDefault();
      e.stopImmediatePropagation();
      notify(verdict.message);
    } else {
      optimisticAdd(addingHandle);
    }
  }, true);

  /* ---------- olaylar ---------- */

  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('ajaxProduct:error', refresh);
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('variant:change', applyToForms);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });

  var moTimer = null;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (moTimer) clearTimeout(moTimer);
      moTimer = setTimeout(applyAll, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyAll();
    refresh();
  });
  refresh();
})();
